<template>
  <div
    class="ma-0 pa-0"
    :class="isOnMobile ? 'box-container' : 'box-container-horizontal'"
    style="width: 100%; height: 100%"
    :style="isOnMobile ? 'flex-direction: column-reverse;' : ''"
  >
    <loading-component v-if="!datatype || datatype.isLoading" style="width: 100%"> </loading-component>
    <error-component
      v-else-if="datatype && datatype.errorMessage"
      :text="datatype.errorMessage"
      align="center"
      justify="center"
      class="row-header ma-0 pa-0"
      style="width: 100%"
    >
    </error-component>
    <div class="row-header ma-0 pa-0 mx-1" v-if="loaded && onfocus">
      <station-list
        class="ma-0 pa-0"
        :showAll="true"
        :showFilters="true"
        :items="getStations"
        :width="isOnMobile ? '100%' : 300"
        :height="isOnMobile ? 300 : '100%'"
        :slotHeight="datatype && datatype.dates ? 40 : 0"
        @stationClick="(station) => stationSelected(station)"
      >
        <template v-slot:top>
          <t-date-range-input
            v-if="datatype && datatype.dates"
            width="100%"
            v-model="datatype.dates"
            label="Период"
            title="Период"
            :clearable="false"
            @change="reloadData()"
          ></t-date-range-input>
        </template>
        <!-- <template v-slot:top>
          <t-date-range-input
            @change="refreshData(false)"
            class="ma-0 pa-0 caption flex-grow-1"
            v-model="getDateheader.filtervalues"
            :title="getDateheader.text"
            :clearable="false"
            :append-icon="getDateheader.filtervalues[0] ? '' : 'mdi-calendar-month'"
            style="width: 260px; max-width: 270px"
            :label="Период"
          ></t-date-range-input>
        </template> -->
      </station-list>
    </div>
    <div class="row-content ma-0 pa-2" v-if="loaded && onfocus">
      <div class="box-container ma-0 pa-0" v-if="hasData">
        <v-row class="row-header ma-2" :class="isOnMobile ? 'ma-1' : ''" justify="start" align="center"> </v-row>
        <v-row class="row-header ma-0 pa-0">
          <v-col cols="12" class="ma-0 pa-0">
            <t-filters v-if="isFilterMenuVisible" :datatype="datatype" />
          </v-col>
        </v-row>
        <div class="row-content ma-0 pa-0" style="overflow: hidden">
          <apex-chart
            ref="refChart"
            width="100%"
            height="100%"
            :type="chartTypes[currentView].type"
            :series="chartSeries"
            :options="getChartOptions"
          ></apex-chart>
        </div>
      </div>
      <error-component v-else text="Няма данни за показване" align="center" justify="center" class="row-header ma-0 pa-0" style="width: 100%">
      </error-component>
    </div>
  </div>
</template>
<script>
import { ref } from "vue";
import DataManager from "@/data/DataManager";
import { DataFilterType, DataPropType } from "@/data/DataFilter";
// import { ColorPalette, g_Dialog } from "../main";
const chart_locales = [
  {
    name: "bg",
    options: {
      months: ["Януари", "Февруари", "Март", "Април", "Май", "Юни", "Юли", "Август", "Септември", "Октомври", "Ноември", "Декември"],
      shortMonths: ["Яну", "Фев", "Мар", "Апр", "Май", "Юни", "Юли", "Авг", "Сеп", "Окт", "Ное", "Дек"],
      days: ["Неделя", "Понеделник", "Вторник", "Сряда", "Четвъртък", "Петък", "Събота"],
      shortDays: ["Нед", "Пон", "Вт", "Ср", "Чет", "Пет", "Съб"],
      toolbar: {
        menu: "Изтегляне на изображение",
        exportToPNG: "Изтегляне в PNG формат",
        exportToSVG: "Изтегляне в SVG формат",
        exportToCSV: "Изтегляне в CSV формат",
        selection: "Избор",
        selectionZoom: "Режим на мащаб",
        zoomIn: "Увеличаване на мащаба",
        zoomOut: "Намаляване на мащаба",
        pan: "Режим на движение",
        reset: "Нулиране на мащаба",
      },
    },
  },
];

export default {
  components: {},
  // inject: ["theme"],
  props: {
    chartTypes: {
      type: Array,
      default: () => [
        {
          text: "Стълбовидно",
          type: "bar",
          stacked: false,
          icon: "mdi-chart-bar",
        },
        {
          text: "Линейно",
          type: "line",
          stacked: false,
          icon: "mdi-chart-bell-curve",
        },
        {
          text: "Процентно",
          type: "pie",
          stacked: false,
          icon: "mdi-chart-pie",
        },
      ],
    },
  },
  data() {
    return {
      datatype: null,
      title: "",
      dates: [],
      isFilterMenuVisible: false,
      predefinedfilters: null,
      currentView: 0,
      chartSeries: [],
      /** @type {ApexCharts.ApexOptions} */
      chartOptions: {
        theme: {
          mode: "light",
        },
        chart: {
          locales: chart_locales,
          defaultLocale: "bg",
          id: this.zzChartId,
          type: "line",
          stacked: false,
          background: this.zzBackground,
          foreColor: this.zzForeground,
          events: {
            // animationEnd: () => {
            //   console.log("animationEnd");
            // },
            beforeZoom: (e, { xaxis }) => {
              // console.log("beforeZoom");
              if (this.isPie()) return;
              var zoomdifference = xaxis.max - xaxis.min;
              var maxdateval = new Date(this.getCategories()[this.getCategories().length - 1]).valueOf();
              if (xaxis.max > maxdateval) {
                xaxis.max = maxdateval;
              }
              var maindifference = maxdateval - new Date(this.getCategories()[0]).valueOf();
              if (zoomdifference > maindifference) {
                return {
                  xaxis: {
                    min: this.isPie() ? undefined : this.getCategories()[0],
                    max: this.isPie() ? undefined : this.getCategories()[this.getCategories().length - 1],
                  },
                };
              } else {
                return {
                  // keep on zooming
                  xaxis: {
                    min: xaxis.min,
                    max: xaxis.max,
                  },
                };
              }
            },
            zoomed: (e, { xaxis }) => {
              // console.log("zoomed");
              if (this.isPie()) {
                return;
              }
              if (xaxis && xaxis.min && xaxis.max) {
                this.zzTickAmount = this.getCategories().filter((f) => new Date(f) >= xaxis.min && new Date(f) <= xaxis.max).length;
                //if (this.zzTickAmount > 0) this.zzTickAmount--;
              } else {
                this.zzTickAmount = this.getCategories().length > 0 ? this.getCategories().length - 1 : 0; //todo?
              }
              this.chartOptions = {
                ...this.chartOptions,
                ...{
                  xaxis: {
                    tickAmount: this.zzTickAmount,
                  },
                },
              };
            },
          },
        },
        dataLabels: {
          enabled: this.zzLabelsVisible || this.isPie(),
        },
        stroke: {
          curve: "smooth",
        },
        xaxis: {
          tickAmount: this.zzTickAmount,
          type: "category",
          categories: [],
          labels: {
            trim: true,
            hideOverlappingLabels: false,
            showDuplicates: false,
          },
          floating: true,
        },
        yaxis: {
          type: "number",
        },
        labels: [],
      },
      zzChartId: "TremolEV",
      zzTheme: "light",
      // zzBackground: "#FFF",
      // zzForeground: "#000",
      zzColors: ["rgb(213, 235, 186)"], //["rgb(0, 152, 70)"],
      zzTickAmount: 10,
      zzLabelsVisible: true,
      loaded: false,
      onfocus: false,
    };
  },
  methods: {
    getXaxisType() {
      if (this.isPie()) {
        return "category";
      } else {
        return this.datatype.chart.xAxisType;
      }
      // else if (this.datatype == DataManager.DataType.monthly || this.datatype == DataManager.DataType.daily_reports || this.datatype == DataManager.DataType.sales_by_payments) {
      //   return "datetime";
      // } else {
      //   return "numeric";
      // }
    },
    showTypePicker() {
      this.dialog.show(
        this.dialog.dialog_types.picker,
        this.chartTypes,
        {
          title: "Изглед на графиката:",
          selected: this.chartTypes[this.currentView],
          width: "400px",
          hideSearch: true,
          toStringFn: (c) => {
            return c.text;
          },
        },
        (res) => {
          if (res) {
            this.loaded = false;
            this.$nextTick(() => {
              this.currentView = this.chartTypes.indexOf(res);
              this.loaded = true;
            });
          }
        }
      );
    },
    /**
     * @param {DataManager.DataType} datatype
     * @param {ErrorMessage} err
     */
    setMeta(meta, err) {
      this.datatype = meta.datatype;
      this.title = this.isOnMobile ? meta.title : meta.description;
      // if (error.ErrorCode == ErrorMessage.ERROR_CODE_OK) {
      // if (this.datatype == DataManager.DataType.sales_by_article_price || this.datatype == DataManager.DataType.sales_by_hours_price) {
      //   this.currentView = 1;
      // }

      if (err.success && !err.message) {
        this.$nextTick(() => {
          this.refreshData(false);
          this.$nextTick(() => {
            this.refreshData(true);
            this.datatype.isLoading = false;
          });
        });
      } else {
        this.datatype.errorMessage = err.message;
        this.datatype.isLoading = false;
      }
    },
    setFocus(on) {
      if (this.$refs.refChart && !on) {
        this.$refs.refChart.destroy();
      }
      this.onfocus = on;
    },
    isPie() {
      return this.chartTypes[this.currentView] && this.chartTypes[this.currentView].type == "pie";
    },
    getIconString(icon) {
      return '<i class="v-icon notranslate mdi ' + icon + " theme--" + this.zzTheme + '" style="font-size: 32px; z-index: 13;"/></i>';
    },
    getCategories() {
      if (!this.datatype) return [];
      if (this.isPie()) return this.datatype.chart.categoriesSUM;
      else return this.datatype.chart.categories;
    },
    getSeries() {
      if (!this.datatype) return [];
      else if (this.isPie()) return this.datatype.chart.seriesSUM;
      else return this.datatype.chart.series;
    },
    showLabels() {
      this.zzLabelsVisible = !this.zzLabelsVisible;
    },
    refreshTheme() {
      if (this.isInDarkMode) {
        if (this.zzTheme == "dark") return;
        // this.zzBackground = "#1E1E1E";
        // this.zzForeground = "#FFF";
        this.zzColors = this.isPie ? undefined : [this.Colors.ActiveItemBackground];
        this.zzTheme = "dark";
      } else {
        if (this.zzTheme == "light") return;
        // this.zzBackground = "#FFF";
        // this.zzForeground = "#000";
        this.zzColors = this.isPie ? undefined : [this.Colors.ActiveItemBackground];
        this.zzTheme = "light";
      }
      this.refreshData(false);
    },
    async reloadData() {
      await DataManager.loadData(this.datatype).then(() => this.refreshData());
    },
    refreshData(refreshOptionsOnly) {
      // this.loaded = false;
      // console.log("refreshData " + refreshOptionsOnly);
      this.zzChartId = (this.zzTitle + "_" + new Date().toStringWithFormat("yyyyMMdd") + "_" + this.chartTypes[this.currentView].text).replaceAll(" ", "-");
      if (this.datatype) {
        if (!refreshOptionsOnly) {
          this.datatype.generateChartData();
        }
        this.zzTickAmount = this.getCategories().length > 0 ? this.getCategories().length - 1 : 0; //todo?
        /** @type {ApexCharts.ApexOptions} */
        this.chartOptions = {
          ...this.chartOptions,
          ...{
            legend: {
              formatter: this.isPie()
                ? function (seriesName, opts) {
                    return (
                      seriesName +
                      " - " +
                      (opts.w.globals.series && opts.w.globals.series.some((f) => f && f > 0)
                        ? ((opts.w.globals.series[opts.seriesIndex] / opts.w.globals.series.sum()) * 100).toFixed(2) + "%"
                        : "0%")
                    );
                  }
                : undefined,
              // width: 150,
              // position: 'right',
            },
            title: {
              //text: this.isOnMobile ? " " : this.zzTitle,
              align: "left",
              style: {
                fontSize: "14px",
                fontWeight: "regular",
                fontFamily: undefined,
              },
            },
            theme: {
              mode: this.zzTheme,
            },
            colors: this.getColors,
            chart: {
              ...this.chartOptions.chart,
              ...{
                zoom: {
                  enabled: true,
                },
                // selection: {
                //   enabled: false,
                // },
                plotOptions: {
                  bar: {
                    distributed: true,
                  },
                },
                id: this.zzChartId.replaceAll("_", ""),
                defaultLocale: "bg",
                type: this.chartTypes[this.currentView].type,
                stacked: this.chartTypes[this.currentView].stacked,

                animations: {
                  speed: 100,
                  animateGradually: {
                    delay: 0,
                  },
                },
                toolbar: {
                  show: true,
                  tools: {
                    customIcons: [
                      {
                        icon: this.getIconString(this.chartTypes[this.currentView].icon),
                        index: this.isPie() ? -1 : -8,
                        title: "Изглед",
                        class: "apexcharts-custom-icon",
                        click: () => {
                          this.showTypePicker();
                        },
                      },
                      // {
                      //   icon: this.getIconString("mdi-home"),
                      //   index: this.isPie() ? -1 : -8,
                      //   title: "Нулиране на мащаба",
                      //   class: "apexcharts-custom-icon",
                      //   click: () => {
                      //     this.resetSeries();
                      //   },
                      // },
                      ...(this.isPie()
                        ? []
                        : [
                            {
                              icon: this.getIconString(this.zzLabelsVisible ? "mdi-label-off-outline" : "mdi-label-outline"),
                              index: 1,
                              title: this.zzLabelsVisible ? "Покажи етикетите" : "Скрий етикетите",
                              class: "apexcharts-custom-icon",
                              click: () => {
                                this.showLabels();
                              },
                            },
                            {
                              icon: this.getIconString("mdi-home"),
                              index: 2,
                              title: "Нулиране на мащаба",
                              class: "apexcharts-custom-icon",
                              click: () => {
                                this.refreshData(true);
                                // this.resetSeries(true, true);
                              },
                            },
                          ]),
                    ],
                    zoomin: this.getIconString("mdi-magnify-plus-outline"),
                    zoomout: this.getIconString("mdi-magnify-minus-outline"),
                    zoom: this.getIconString("mdi-magnify-scan"),
                    reset: false, //this.getIconString("mdi-home"),
                    selection: false,
                    pan: false, // this.getIconString("mdi-cursor-move"),
                    download: this.getIconString("mdi-download"),
                  },
                  export: {
                    csv: {
                      filename: "TremolEV_" + this.zzChartId,
                    },
                    svg: {
                      filename: "TremolEV_" + this.zzChartId,
                    },
                    png: {
                      filename: "TremolEV_" + this.zzChartId,
                    },
                  },
                },
              },
            },
            xaxis: {
              type: this.getXaxisType(),
              tickPlacement: "between",
              tickAmount: this.zzTickAmount,
              labels: {
                formatter: this.datatype.chart.formatterX,
                hideOverlappingLabels: false,
              },
              overwriteCategories: false,
              min: this.isPie() || this.getCategories().length == 0 ? undefined : this.getCategories()[0].valueOf(),
              max: this.isPie() || this.getCategories().length == 0 ? undefined : this.getCategories()[this.getCategories().length - 1].valueOf(),
              categories: this.getCategories(),
            },
            yaxis: {
              labels: {
                formatter: this.datatype.chart.formatterY,
              },
              axisBorder: {
                show: true,
                color: "#05733F",
              },
              axisTicks: {
                show: true,
                borderType: "solid",
              },
              tooltip: {
                enabled: true,
              },
            },
            // colors: ColorPalette,
            dataLabels: {
              style: {
                colors: this.isPie() ? undefined : [this.Colors.MenuTextColor],
              },
              enabled: this.zzLabelsVisible || this.isPie(),
              formatter: this.isPie()
                ? function (val) {
                    return !val ? "0%" : val.toFixed(2) + "%";
                  }
                : this.datatype.chart.formatterY,
            },
            tooltip: {
              enabled: !this.hideTooltips,
              y: {
                formatter: this.datatype.chart.formatterY,
                title: {
                  formatter: this.datatype.chart.formatterTooltip,
                },
              },
            },
            labels: this.getCategories(),
          },
        };
        if (!refreshOptionsOnly) {
          this.chartSeries = this.getSeries();
        }
      } else {
        this.chartOptions = {
          ...this.chartOptions,
          ...{
            noData: {
              text: "",
            },
            title: {
              //text: this.isOnMobile ? " " : this.zzTitle,
              align: "left",
            },
          },
        };
      }
      this.loaded = true;
    },
    resetSeries(shouldUpdateChart, shouldResetZoom) {
      this.$nextTick(() => {
        // setTimeout(() => {
        if (this.$refs.refChart) {
          this.$refs.refChart.resetSeries(shouldUpdateChart, shouldResetZoom);
          if (this.$refs.refChart.$el) {
            try {
              this.$refs.refChart.$el.getElementsByClassName("apexcharts-element-hidden").forEach((e) => {
                e.classList.remove("apexcharts-element-hidden");
              });
            } catch {
              /**ignored */
            }
          }
        } else {
          // console.log("no chart");
        }
        // }, 500);
      });
    },
    stationSelected(station) {
      this.datatype.headers.find((h) => h.value == "ChargeStation").filtervalues = [station];
      this.$nextTick(() => {
        this.refreshData(false);
      });
    },

    getFiltersUniqueValues(filter) {
      return DataManager.getFilterDistinctValues(this.datatype, filter).reverse();
      //return this.dataitems.map((f) => f[filter.propname]).unique();
    },
    appenFilter(filter) {
      DataManager.appendFilter(this.datatype, filter);
    },
  },
  computed: {
    getColors() {
      return this.isPie() ? undefined : [this.Colors.ActiveItemBackground];
    },
    getStations() {
      if (!this.datatype) return [];
      return DataManager.getData(DataManager.data.ChargeStation) ?? [];
    },
    getChartOptions() {
      return this.chartOptions;
    },
    DataFilterType() {
      return DataFilterType;
    },
    DataPropType() {
      return DataPropType;
    },
    hasData() {
      return (
        this.datatype != null &&
        this.chartSeries.length > 0 &&
        (!this.isPie() ? this.chartSeries[0].data && this.chartSeries[0].data.length > 0 : this.chartSeries.length > 0)
      );
    },
  },
  updated() {
    this.refreshTheme();
  },
  created() {},
  mounted() {
    // bus.$on(bus.EVENT_DataManager_FILTERS_CHANGED, async (datatype) => {
    //   if (datatype == this.datatype && this.onfocus) {
    //     this.predefinedfilters.forEach((f) => {
    //       var found = DataManager.getFilters(this.datatype.id).find((ff) => f.propname == ff.propname);
    //       if (found) {
    //         f.vals = found.vals;
    //       } else {
    //         f.vals = [];
    //       }
    //     });
    //     this.convertDataToChartData();
    //   }
    // });
  },
  unmounted() {},
  watch: {
    isInDarkMode: function () {
      this.refreshTheme();
    },
    currentView: {
      handler(oldVal, newVal) {
        this.refreshData(!(newVal != oldVal && (this.chartTypes[newVal].type == "pie" || this.chartTypes[oldVal].type == "pie")));
      },
    },
    zzLabelsVisible: function () {
      this.refreshData(true);
    },
  },
  setup() {
    const refChart = ref(null);
    return { refChart };
  },
};
</script>
<style scoped>
div >>> .apexcharts-toolbar {
  max-width: 320px;
  width: auto;
  height: 32px;
}

div >>> .apexcharts-legend {
  padding-top: 6px;
}

div >>> .apexcharts-zoomin-icon,
div >>> .apexcharts-zoomout-icon,
div >>> .apexcharts-zoom-icon,
div >>> .apexcharts-pan-icon,
div >>> .apexcharts-reset-icon,
div >>> .apexcharts-menu-icon,
div >>> .apexcharts-custom-icon {
  height: 32px;
  width: 32px;
  margin-right: 5px;
}
</style>